export default "__VITE_ASSET__665989dd__"